import React, { useState } from "react";

import toast from 'react-hot-toast';
import axios from "axios";

import CustomDropdown from "../../ReUseable/Dropdown/CustomDropdown";
import CustomTimePicker from "../../ReUseable/CustomTimePicker/CustomTimePicker";
import CustomDatePicker from "../../ReUseable/CustomDatePicker/CustomDatePicker";
import Success from "../../ReUseable/Success/Success";
import { API } from "../../../global";
import Loader from "../../ReUseable/Loader/Loader";

const ScheduleFrequency = (props) => {
  const { setShowScheduleOptions, clearStates, setShowRunOrSchedule, setDestinationStepper } = props;

  const [frequency, setFrequency] = useState("Once");
  const [onceDate, setOnceDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("12:00 PM");
  const [selectedDay, setSelectedDay] = useState("Sunday");
  const [monthlyDayOption, setMonthlyDayOption] = useState("Start date of each month");
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFrequencyChange = (option) => {
    setFrequency(option);
    if (option === "Once") {
      setOnceDate(new Date());
    } else {
      setStartDate(new Date());
      setEndDate(new Date());
    }
  };

  const handleDayChange = (option) => {
    if (frequency === "Weekly") {
      setSelectedDay(option);
    } else if (frequency === "Monthly") {
      setMonthlyDayOption(option);
    }
  };

  const handleSchedule = async () => {
    try {
      setLoading(true);
      let scheduleDetails = {
        occurrence: frequency,
        date: "",
        startDate: "",
        endDate: "",
        time: "",
        day: "",
        pipelineId: localStorage.getItem("pipelineId")
      };

      if (frequency === "Once") {
        scheduleDetails.date = onceDate;
        scheduleDetails.time = selectedTime;
      } else if (frequency === "Daily") {
        scheduleDetails.startDate = startDate;
        scheduleDetails.endDate = endDate;
        scheduleDetails.time = selectedTime;
      } else if (frequency === "Hourly") {
        scheduleDetails.startDate = startDate;
        scheduleDetails.endDate = endDate;
      } else if (frequency === "Weekly") {
        scheduleDetails.startDate = startDate;
        scheduleDetails.endDate = endDate;
        scheduleDetails.day = selectedDay;
        scheduleDetails.time = selectedTime;
      } else if (frequency === "Monthly") {
        scheduleDetails.startDate = startDate;
        scheduleDetails.endDate = endDate;
        scheduleDetails.day = monthlyDayOption;
        scheduleDetails.time = selectedTime;
      }

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`
        }
      };
      const res = await axios.post(`${API}/schedule-task/create`, scheduleDetails, config);
      if (res.data.success) {
        setIsSuccess(true);
        setDestinationStepper(true);
        setLoading(false);
      } else {
        toast.error(res.data.error.msg);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error('It appears that there is an error in the backend API. Please ensure that you have prepared the system before proceeding with your workflow.');
    }
  };

  const handleCancel = () => {
    setShowScheduleOptions(false);
  };

  const clearStatesUpdated = () => {
    clearStates();
    setShowRunOrSchedule(false);
    setShowScheduleOptions(false);
  }

  const handleDateChange = (date) => {
    setOnceDate(date);
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
  }

  const handleEndDateChange = (date) => {
    const updatedDate = new Date(date);
    updatedDate.setHours(12, 0, 0, 0);
    setEndDate(updatedDate);
  }

  const handleTimeChange = (newHours, newMinutes, newAmPm) => {
    setSelectedTime(`${newHours}:${newMinutes} ${newAmPm}`);
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : isSuccess ? (
        <Success
          clearStates={clearStatesUpdated}
          message="The task has been scheduled successfully."
        />
      ) : (
        <div className="flex flex-col items-center rounded-md w-[480px] mx-auto mt-10 xl:mt-16 text-sm">
          <h2 className="text-xl font-medium mb-2">Schedule Frequency</h2>
          <hr className="w-full border-t-2 border-[#0083BF] mb-6" />

          <div className="flex justify-between w-full mb-4 items-center">
            <label htmlFor="frequency" className="block text-sm font-medium text-[#333333]">
              Repeat
            </label>
            <div className="w-[70%]">
              <CustomDropdown
                options={["Once", "Hourly", "Daily", "Weekly", "Monthly"]}
                placeholder="Select frequency"
                onSelect={handleFrequencyChange}
                selected={frequency}
              />
            </div>
          </div>

          {frequency === "Once" && (
            <div className="flex justify-between w-full mb-4 items-center">
              <label htmlFor="once-date" className="block text-sm font-medium text-[#333333]">
                Date
              </label>
              <div className="w-[70%]">
                <CustomDatePicker
                  selected={onceDate}
                  onSelect={handleDateChange}
                />
              </div>
            </div>
          )}

          {frequency !== "Once" && (
            <>
              <div className="flex justify-between w-full mb-4 items-center">
                <label htmlFor="start-date" className="block text-sm font-medium text-[#333333]">
                  Start Date
                </label>
                <div className="w-[70%]">
                  <CustomDatePicker
                    selected={startDate}
                    onSelect={handleStartDateChange}                    
                  />
                </div>
              </div>

              <div className="flex justify-between w-full mb-4 items-center">
                <label htmlFor="end-date" className="block text-sm font-medium text-[#333333]">
                  End Date
                </label>
                <div className="w-[70%]">
                  <CustomDatePicker
                    selected={endDate}
                    onSelect={handleEndDateChange}
                  />
                </div>
              </div>
            </>
          )}

          {frequency === "Weekly" && (
            <div className="flex justify-between w-full mb-4 items-center">
              <label htmlFor="day" className="block text-sm font-medium text-[#333333]">
                Day
              </label>
              <div className="w-[70%]">
                <CustomDropdown
                  options={["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]}
                  placeholder="Select day"
                  onSelect={handleDayChange}
                  selected={selectedDay}
                />
              </div>
            </div>
          )}

          {frequency === "Monthly" && (
            <div className="flex justify-between w-full mb-4 items-center">
              <label htmlFor="monthly-option" className="block text-sm font-medium text-[#333333]">
                Day
              </label>
              <div className="w-[70%]">
                <CustomDropdown
                  options={["Start date of each month", "End date of each month"]}
                  placeholder="Select option"
                  onSelect={handleDayChange}
                  selected={monthlyDayOption}
                />
              </div>
            </div>
          )}

          {frequency !== "Hourly" && (
            <div className="flex justify-between w-full mb-4 items-center">
              <label htmlFor="time" className="block text-sm font-medium text-[#333333]">
                Time
              </label>
              <div className="w-[70%]">
                <CustomTimePicker
                  onSelect={handleTimeChange}
                  selected={selectedTime}
                />
              </div>
            </div>
          )}

          <div className="flex justify-end w-full gap-4">
            <button
              className="py-1 px-4 bg-gray-200 text-gray-700 rounded-md"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="py-1 px-4 bg-[#0083BF] text-white rounded-md"
              onClick={handleSchedule}
            >
              Schedule
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ScheduleFrequency;